import React, { useContext, Fragment, useState, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Drawer,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import DataContext from '../data/DataContext';
import Error from '../../asset/img/icon_error.svg';
import Terms3 from './Terms3';
import CheckOn from '../../asset/img/icon_checkbox_on.svg';
import CheckOff from '../../asset/img/icon_checkbox_off.svg';
import Close from '../../asset/img/icon_close.svg';
import { useForm } from 'react-hook-form';
const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.5px',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: '100%',
    overflowY: 'auto',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  drawerHeaderClose: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
  },

  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '40px 20px 15px !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '15px',
    '& button': {
      height: '50px',
      width: '50%',
      borderRadius: '6px',
      border: 'solid 1px #ea1917', //"solid 1px #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  divider: {
    height: '1px',
    backgroundColor: theme.color.divider.grey,
    width: '100%',
  },
  buttonBoxRoundTop: {
    borderRadius: '10px 10px 0 0',
  },
  buttonBoxRoundBottom: {
    borderRadius: '0 0 10px 10px',
  },
  buttonStrBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  buttonStrText: {
    fontSize: theme.font.size12,
    color: theme.color.message.grey,
    margin: '0 0 2px 0',
  },
  buttonStrTitle: {
    fontSize: theme.font.size15,
    color: theme.color.message.color,
    fontWeight: 'bold',
  },
  buttonIcon: {
    minWidth: '1rem',
    minHeight: '1rem',
  },

  button: {
    minHeight: '2.5rem',
    textAlign: 'center',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0px',
    margin: '0px',
    flex: 1,
    backgroundColor: '#ea1917', //"#da0f47;",
    textTransform: 'none',
    // outline: '0 none',
    border: '0px',
    // borderRadius: "0px 0px 12px 12px",
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '2.5rem',
    color: '#fff',
    padding: '0px 20px',
    fontSize: theme.font.size14,
    textAlign: 'center',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 16px',
    marginTop: '16px',
    placeContent: 'center',
    borderTop: '1px solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '12px 16px 0px 16px',
  },
  modalGridItemLabelFirst: {
    padding: '4px 16px 0px 16px',
  },
  modalGridItem: {
    padding: '12px 16px',
  },
  modalLabel: {
    // minHeight: "20px",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  textareaField: {
    position: 'relative',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '7.5rem',
    border: '0.0625rem solid #929292',
    borderRadius: '0.375rem 0.375rem 0 0',
    fontSize: theme.font.size12,
    padding: '1rem',
    lineHeight: '1.72',
    '& .termsDl': {
      height: '5.45rem',
      overflow: 'auto',
    },
    '& dl': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& dd': {
      marginInlineStart: '0rem',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0rem',
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& ol.termsOl>li': {
      paddingBlockStart: '0.5rem',
      '&:first-child': {
        paddingBlockStart: '0rem',
      },
    },
    '& ul': {
      paddingInlineStart: '0.625rem',
    },
    '& dt': {
      fontWeight: 'bold',
    },
    '& .layerPopupTop': {
      display: 'none',
    },
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
    '& .termsDl .blind': {
      display: 'none',
    },
    '& .layerPopupBottom': {
      display: 'none',
    },
  },
  termTextContent: {
    height: '5.45rem',
    overflowY: 'scroll',
  },
  checkArea: {
    height: '3rem',
    border: '0.0625rem solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 0.375rem 0.375rem',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    '& input+label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOff}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input:checked + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input': {
      height: '1.25rem',
      width: '1.25rem',
      marginRight: '0.375rem !important',
      display: 'none',
    },
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  errorIcon: {
    width: '12px',
    height: '12px',
    color: '#ff3723',
    marginRight: '3px',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
  modalField: {
    // paddingTop: "12px",
    '& input': {
      borderRadius: '6px',
      width: '100%',
      height: '46px',
      border: 'solid 1px #929292',
      padding: '13px 16px',
    },
    // }
  },
  inputNormal: {
    borderRadius: '6px',
    width: '100%',
    height: '46px',
    border: 'solid 1px #929292',
    padding: '13px 16px',
    fontSize: theme.font.size14,
  },

  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    // border: "solid 1px #000",
    // backgroundColor: "#fff",
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    // color: "#000",
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
  time: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
    // textAlign: "center",
    color: '#ff3723',
    // position: "absolute",
    // paddingTop: "14px",
    marginLeft: '-40px',
  },
  redButton: {
    color: theme.color.button.rbut_text,
    backgroundColor: theme.color.button.rbut_bg,
    border: '0',
  },
  redButtonDisable: {
    color: theme.color.button.rbut_text_disable,
    backgroundColor: theme.color.button.rbut_bg_disable,
    border: '0',
  },
  whiteButton: {
    color: theme.color.button.wbut_text,
    backgroundColor: theme.color.button.wbut_bg,
    border: `solid 1px ${theme.color.button.wbut_border}`,
  },
  whiteButtonDisable: {
    color: theme.color.button.wbut_text_disable,
    backgroundColor: theme.color.button.wbut_bg_disable,
    border: `solid 1px ${theme.color.button.wbut_border_disable}`,
  },
  normalButton: {
    color: theme.color.text_color.black,
    backgroundColor: theme.color.button.background_white,
    border: `solid 1px ${theme.color.text_color.black}`,
  },
  normalButtonDisable: {
    color: theme.color.button.text_red_disable,
    backgroundColor: theme.color.button.background_white_disable,
    border: `solid 1px ${theme.color.button.background_red_disable}`,
  },
  inputDisable: {
    backgroundColor: theme.color.input.modal_disable,
    border: '0',
  },
  errorPopupContainer: {
    position: 'absolute',
    zIndex: '10',
    // bottom: "100px",
    width: '100%',
    padding: '0 16px',
    margin: '-40px 0 0 0 ',
  },
  fadeoutEffect: {
    transition: 'all .5s ease-in-out',
  },
  errorPopupClosed: {
    height: 0,
  },
  errorPopup: {
    borderRadius: '6px',
    boxShadow: '4px 4px 24px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    textAlign: 'left',
    padding: '16px 20px',
    color: theme.color.button.text_white,
    lineHeight: '1.43',
    letterSpacing: 'normal',
    fontSize: theme.font.size14,
    // margin: "0 16px"
  },
  codeBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  textarea: {
    width: '100%',
    height: '9.375rem',
    borderRadius: '0.375rem',
    background: '#fff',
    font: 'inherit',
    fontSize: '0.875rem',
    padding: '0.8125rem 1rem 2.1875rem',
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  textCount: {
    font: 'inherit',
    fontSize: '0.75rem',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '0.875rem',
    right: '1rem',
  },
  input: {
    fontSize: theme.font.size14,
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
});
const Input = withStyles(styles)((props) => {
  const { classes, register, label, req, errors } = props;
  return (
    <Fragment>
      <input
        {...props}
        {...register(label, req)}
        className={[classes.error, classes.input].join(' ')}
      />
      {errors[label] && <ErrorMsg text={[errors[label].message]} />}
    </Fragment>
  );
});
const ErrorMsg = withStyles(styles)((props) => {
  const { classes, text } = props;
  return (
    <Fragment>
      <div className={classes.errorText}>
        <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
        {text}
      </div>
    </Fragment>
  );
});
const ReserveCallModal = withStyles(styles)((props) => {
  const { classes, modalClose, data, customClose, setCloseDialogOpen } = props;
  const userInfo = data?.modal.data.user;
  const context = useContext(DataContext);
  const [username, setUsername] = useState(userInfo?.user_name || '');
  const [phonenum, setPhonenum] = useState(userInfo?.phone_number || '');

  const [descText, setDescText] = useState('');
  const [termText, setTermText] = useState('');
  const [termModalOpen, setTermModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const handleCheckClick = () => {
    setChecked((prev) => !prev);
    // dispatch()
  };
  const dispatch = () => {
    console.log('dispathch....');
    var input = document.querySelector('input[name="checkHidden"]');
    const event = new Event('input', { bubbles: true });
    const tracker = input._valueTracker;
    if (tracker) {
      tracker.setValue('');
    }
    input.dispatchEvent(event);
  };
  const descTextMax = 100;
  const minDigitCount = 9;

  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermText(term_text);
    })();
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const usernameHandler = (event) => {
    const tempUsername = event.target.value;
    console.log(tempUsername);
    setUsername(tempUsername);
  };

  const phonenumHandler = (event) => {
    const tempPhonenum = event.target.value;
    console.log(tempPhonenum);
    setPhonenum(tempPhonenum);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setDescText(value);
  };

  const handleClickConfirm = () => {
    console.log('handleSubmit');
    let dataExpect = data?.expect || {
      mode: 'bypass',
      intent: 'THQ_INQUIRY_BY_CALL',
    };
    let dataParameters = data?.parameters;
    let phonenumNumOnly = phonenum.replace(/[^0-9]/g, '');
    let reserveData = data?.modal.data;

    let tempData = {
      custName: username,
      rcptUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3',
      telNo1_1: phonenumNumOnly.substr(0, 3),
      telNo1_2:
        phonenumNumOnly.length === 10
          ? phonenumNumOnly.substr(3, 3)
          : phonenumNumOnly.substr(3, 4),
      telNo1_3: phonenumNumOnly.substr(phonenumNumOnly.length - 4, 4),
      counselDetail: descText,
      personInfoAgreeFlag: checked ? 'Y' : 'N',
      gscs_product_code: reserveData?.gscs_product_code,
      gscs_product_name: reserveData?.gscs_product_name,
      productCode: reserveData?.sfdc_product_code,
      comment: reserveData?.comment,
      bypass_br: 'reservation',
    };

    context.request(
      context,
      dataParameters?.sppech || '확인',
      'button',
      {
        ...reserveData,
        ...dataParameters,
        ...tempData,
      },
      dataExpect
    );
    modalClose();
  };

  const phoneValidator = (telNum) => {
    var ment = '';
    var tel1 = '';
    var tel2 = '';
    var tel3 = '';
    var tel2_ = '';
    var result = '휴대전화 번호를 정확히 입력해 주세요';

    try {
      tel1 = telNum.substr(0, 3);
      tel2 = telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4);
      tel3 = telNum.substr(telNum.length - 4, 4);
      tel2_ = telNum.substr(3, 1);

      if (
        (tel1 === '011' ||
          tel1 === '016' ||
          tel1 === '017' ||
          tel1 === '018' ||
          tel1 === '019') &&
        tel2.length === 3
      ) {
        if (tel2 >= 200 && tel2 <= 899) {
          //return true;
        } else {
          ment =
            '국번 번호는 "200~899" 만 허용하며, "000~199", "900~999" 허용 불가합니다.';
        }
      }
      if (ment === '') {
        switch (tel1) {
          case '010':
            if (tel2_ === '0' || tel2_ === '1') {
              ment = '국번 번호의 첫자리가 "0, 1"은 잘못된 국번입니다.';
            } else {
              /*return true;*/
            }
            break;
          case '011':
            if (tel2.length === 4) {
              if ((tel2 >= 1700 && tel2 <= 1799) || (tel2 >= 9500 && tel2 <= 9999)) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "1700~1799" 또는 "9500~9999" 만 허용합니다.';
              }
            } else if (tel2.length === 3) {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "200~899" 만 허용합니다.';
              }
            }
            break;
          case '016':
          case '019':
            if ((tel2 >= 200 && tel2 <= 899) || (tel2 >= 9000 && tel2 <= 9999)) {
              //return true;
            } else {
              ment =
                '국번 번호 범위가 맞지 않습니다. "016, 019" 이면 "9000~9999" 까지만 허용합니다.';
            }
            break;
          case '017':
          case '018':
            if (tel2.length === 4) {
              ment = '"017, 018"의 경우 국번은 4자리이면 안됩니다.';
            } else {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "017, 018" 이면 "200~899" 까지만 허용합니다.';
              }
            }
            break;
          default:
            ment = '"010, 011, 016, 017, 018, 019" 만 허용합니다.';
            break;
        }
      }
      return ment === '' || result;
    } catch (er) {
      return result;
    } finally {
      console.log(
        '휴대폰번호 유효성 검사결과 : [tel1:' +
          tel1 +
          ', tel2:' +
          tel2 +
          ', tel3:' +
          tel3 +
          ', tel2_:' +
          tel2_ +
          ']' +
          ment
      );
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(handleClickConfirm)}>
        <Grid container className={classes.modalGridContainer}>
          {/* 이름 */}
          <Grid
            item
            xs={12}
            className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
              ' '
            )}
          >
            <div className={classes.modalLabel}>
              이름<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="user_name"
                register={register}
                errors={errors}
                req={{
                  required: '이름을 입력해주세요.',
                  minLength: { value: 1, message: '이름을 입력해주세요.' },
                  maxLength: { value: 25, message: '최대 입력 길이를 초과하였습니다.' },
                  pattern: {
                    value: /^[ㄱ-ㅎ가-힣a-zA-Z|]+$/gi,
                    message: '이름은 한글, 영문만 가능합니다.',
                  },
                  disabled: userInfo?.user_name ? true : false,
                  onChange: usernameHandler,
                }}
                value={username}
                placeholder="이름을 입력해주세요."
                disabled={userInfo?.user_name ? true : false}
              />
            </div>
          </Grid>
          {/* 휴대전화번호 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              휴대전화번호<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="phone_number"
                register={register}
                errors={errors}
                req={{
                  required: '휴대전화 번호를 입력해 주세요.',
                  minLength: {
                    value: 10,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  maxLength: {
                    value: 11,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  // pattern: {value:/^[0-9]*$/gi, message:'숫자만 입력 가능합니다.'},
                  pattern: {
                    value: /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/gi,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  validate: { phoneValidator },
                  disabled: userInfo?.phone_number ? true : false,
                  onChange: phonenumHandler,
                }}
                value={phonenum}
                disabled={userInfo?.phone_number ? true : false}
                placeholder="'-'를 제외한 휴대전화 번호를 입력해 주세요."
                type="tel"
                maxLength="11"
              />
            </div>
          </Grid>
          {/* 휴대전화번호 재확인*/}
          {!data?.modal?.data?.user?.phone_number && (
            <Fragment>
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={classes.modalLabel}>
                  휴대전화번호 재확인<span className="star">*</span>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.modalGridItem}>
                <div className={classes.modalField}>
                  <Input
                    label="phone_number2"
                    register={register}
                    errors={errors}
                    req={{
                      validate: (value) =>
                        value === phonenum || '휴대전화 번호가 일치하지 않아요.',
                    }}
                    placeholder="휴대전화 번호를 다시 입력해 주세요."
                    type="tel"
                    maxLength="11"
                  />
                </div>
              </Grid>
            </Fragment>
          )}
          {/* 전달사항 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>전달사항(선택)</div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={[classes.modalField, classes.textareaField].join(' ')}>
              <textarea
                className={classes.textarea}
                placeholder="상담사에게 미리 공지해야 하는 내용이 있다면 자유롭게 작성해주세요."
                maxLength={descTextMax}
                name="desc"
                onChange={handleChange}
                // value={basicInfo.desc||""}
                value={descText}
                // maxlength={100}
              />
              <span className={classes.textCount}>
                {descText.length}/{descTextMax}자
              </span>
            </div>
          </Grid>
        </Grid>

        <Fragment>
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={[classes.modalLabel, classes.terms].join(' ')}>
              <div>
                개인정보 수집 및 이용동의<span className="star">*</span>
              </div>
              <button
                className={classes.showAll}
                onClick={() => {
                  setTermModalOpen(true);

                  const rootChild = document.getElementById('modal');
                  const focusableElements = rootChild.querySelectorAll('*');

                  for (let i = 0; i < focusableElements.length; i++) {
                    focusableElements[i].setAttribute('aria-hidden', 'true');
                  }
                }}
              >
                전문보기
              </button>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={[classes.modalField, classes.textareaField].join(' ')}>
              <div className={classes.termTextArea}>
                <div
                  className={classes.termTextContent}
                  dangerouslySetInnerHTML={{ __html: termText }}
                />
              </div>
              <input
                type="hidden"
                value={checked}
                {...register('terms', { validate: () => checked })}
                name="checkHidden"
              />
              <div className={classes.checkArea}>
                <input
                  id="term_check"
                  type="checkbox"
                  checked={checked}
                  onClick={handleCheckClick}
                />
                <label
                  for="term_check"
                  role="checkbox"
                  aria-checked={checked}
                  tabindex="0"
                >
                  동의합니다
                </label>
              </div>
            </div>
            {errors.terms && (
              <div className={classes.errorText}>
                <img src={Error} className={classes.errorIcon} alt="체크 필요" />
                먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
              </div>
            )}
          </Grid>
        </Fragment>

        {/* footer button */}
        <Grid container className={classes.modalFooter}>
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button
              type="button"
              className={classes.modalButton}
              onClick={() => setCloseDialogOpen(true)}
            >
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={classes.modalButtonRight}>
            <button
              type="submit"
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
            >
              확인
            </button>
          </Grid>
        </Grid>
      </form>
      <Terms3
        modalOpen={termModalOpen}
        modalClose={() => {
          setTermModalOpen(false);
          const rootChild = document.getElementById('modal');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].removeAttribute('aria-hidden');
          }
        }}
        checkOk={(ok) => {
          setChecked(ok);
        }}
      />
    </Fragment>
  );
});

function ReserveCall(props) {
  const { classes, data, modalOpen, modalClose } = props;
  const context = useContext(DataContext);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const cancelReserve = () => {
    let dataExpect = data?.expect || {
      mode: 'bypass',
      intent: 'THQ_INQUIRY_BY_CALL',
    };
    let dataParameters = data?.parameters;

    context.request(
      context,
      dataParameters?.sppech || '그만하기',
      'button',
      {
        ...dataParameters,
        bypass_br: 'cancel',
      },
      dataExpect
    );
    setCloseDialogOpen(false);
    modalClose();
  };

  return (
    <div className={classes.root}>
      <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={() => setCloseDialogOpen(true)}
        classes={{ paper: classes.drawerFrame }}
      >
        <div className={classes.drawerRoot}>
          <div className={classes.drawerHeaderClose}>
            <div className={[classes.titleClose].join(' ')}>전화 상담 예약</div>
            <div className={classes.close}>
              <img
                src={Close}
                className={classes.arrowDown}
                onClick={() => setCloseDialogOpen(true)}
              />
            </div>
          </div>
          <Divider classes={{ root: classes.dividerTitle }} />
          <div className={classes.componentWrapper}>
            <ReserveCallModal
              data={data}
              modalOpen={modalOpen}
              modalClose={modalClose}
              setCloseDialogOpen={setCloseDialogOpen}
            />
          </div>
        </div>
      </Drawer>
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button className={classes.dialogFooterBtnLeft} onClick={() => cancelReserve()}>
            그만하기
          </button>
          <button
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withStyles(styles)(ReserveCall);
